import { Phone, MessageCircle, Mail, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const StickyContactBar = () => {
  const handleCall = () => window.location.href = "tel:4074509182";
  const handleText = () => window.location.href = "sms:4074509182?body=Hi!%20I'm%20interested%20in%20a%2090%2B%20day%20rental.";
  const handleEmail = () => window.location.href = "mailto:RAEVenturesLLC@gmail.com?subject=Extended%20Stay%20Inquiry";

  return (
    <>
      {/* Desktop Floating Buttons */}
      <div className="fixed bottom-8 right-6 z-40 hidden md:flex flex-col gap-3">
        <Button
          onClick={handleCall}
          className="w-14 h-14 rounded-full bg-[#0A1628] text-white hover:bg-[#1E3A5F] shadow-lg flex items-center justify-center p-0"
          title="Call Now"
          data-testid="floating-call-btn"
        >
          <Phone className="w-5 h-5" />
        </Button>
        <Button
          onClick={handleText}
          className="w-14 h-14 rounded-full bg-[#C9A962] text-[#0A1628] hover:bg-[#B8954D] shadow-lg flex items-center justify-center p-0"
          title="Text Us"
          data-testid="floating-text-btn"
        >
          <MessageCircle className="w-5 h-5" />
        </Button>
        <Button
          onClick={handleEmail}
          className="w-14 h-14 rounded-full bg-white text-[#0A1628] hover:bg-[#F7F3ED] shadow-lg border border-[#EDE7DB] flex items-center justify-center p-0"
          title="Email"
          data-testid="floating-email-btn"
        >
          <Mail className="w-5 h-5" />
        </Button>
      </div>

      {/* Mobile Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0A1628] border-t border-white/10 px-4 py-3 safe-area-pb">
        <div className="grid grid-cols-4 gap-2">
          <button
            onClick={handleCall}
            className="flex flex-col items-center gap-1 text-white/80 hover:text-white transition-colors"
            data-testid="mobile-call-btn"
          >
            <Phone className="w-5 h-5" />
            <span className="text-[10px] font-medium">Call</span>
          </button>
          <button
            onClick={handleText}
            className="flex flex-col items-center gap-1 text-white/80 hover:text-white transition-colors"
            data-testid="mobile-text-btn"
          >
            <MessageCircle className="w-5 h-5" />
            <span className="text-[10px] font-medium">Text</span>
          </button>
          <button
            onClick={handleEmail}
            className="flex flex-col items-center gap-1 text-white/80 hover:text-white transition-colors"
            data-testid="mobile-email-btn"
          >
            <Mail className="w-5 h-5" />
            <span className="text-[10px] font-medium">Email</span>
          </button>
          <a
            href="/contact"
            className="flex flex-col items-center gap-1 text-[#C9A962] hover:text-[#B8954D] transition-colors"
            data-testid="mobile-quote-btn"
          >
            <Calendar className="w-5 h-5" />
            <span className="text-[10px] font-medium">Quote</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default StickyContactBar;
